import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/common.css'
import 'swiper/swiper.css'
import 'swiper/modules/scrollbar.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)
Vue.use(Element)
Vue.config.productionTip = false

import './style/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer, {
  defaultOptions: {
    navbar: false,
    title: false,
    toolbar: true,
    movable: false
  }
})

Vue.prototype.stopScroll = function() {
  var mo = function(e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}

// 弹出框可以滑动
Vue.prototype.canScroll = function() {
  var mo = function(e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
